import { IThreshold } from "./Threshold";
import { IEntity, Entity, IEntityWithCustomer, EntityWithCustomer } from "./Entity";

export interface IThresholdAppetite extends IEntityWithCustomer {
    ID: number;
    ThresholdID: number | null;
    RiskImpactLevelID: number | null;
    RiskProbabilityID: number | null;
    Acceptable: boolean;

    Threshold?: IThreshold;
    RiskProbability?: IEntity;
    RiskImpactLevel?: IEntity;

}

export class ThresholdAppetite extends EntityWithCustomer implements IThresholdAppetite {
    public ThresholdID = null;
    public RiskProbabilityID = null;
    public RiskImpactLevelID = null;
    public Acceptable = false;
}
